import React from 'react';
import { EVENTS_BATCH_SIZE } from '../../constants/eventGrid';

export function EventCardSkeleton() {
  return (
    <div className="bg-white rounded-lg border border-gray-100 overflow-hidden shadow-sm animate-pulse">
      <div className="aspect-[540/675] bg-gray-200" />
      <div className="p-3 space-y-2.5">
        <div className="h-2.5 bg-gray-200 rounded w-16" />
        <div className="h-3.5 bg-gray-200 rounded w-full" />
        <div className="h-3 bg-gray-200 rounded w-4/5" />
        <div className="flex justify-between items-center pt-1">
          <div className="h-3 bg-gray-200 rounded w-14" />
          <div className="h-7 bg-gray-200 rounded w-20" />
        </div>
      </div>
    </div>
  );
}

const DEFAULT_GRID =
  'grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4';

const EventGridSkeleton = ({
  count = EVENTS_BATCH_SIZE,
  className = DEFAULT_GRID
}) => (
  <div className={className} aria-busy="true" aria-label="Loading events">
    {Array.from({ length: count }).map((_, i) => (
      <EventCardSkeleton key={i} />
    ))}
  </div>
);

export default EventGridSkeleton;
